import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-84303').catch(console.error);
